const AVATAR_PALETTE = [
  '#1868db', // blue
  '#16a34a', // green
  '#b45309', // amber
  '#7c3aed', // violet
  '#0891b2', // cyan
  '#db2777', // pink
  '#4338ca', // indigo
  '#c2410c', // orange
];

/** Formats a patient name as "Firstname L" (first name + capitalized first letter of last name) — never the full last name. */
export function formatPatientName(firstName: string, lastName: string): string {
  const first = (firstName || '').trim();
  const lastInitial = (lastName || '').trim().charAt(0).toUpperCase();
  if (!first && !lastInitial) return '';
  return lastInitial ? `${first} ${lastInitial}` : first;
}

export function getInitials(fullName: string): string {
  if (!fullName) return '?';
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export function getAvatarColor(seed: string): string {
  if (!seed) return AVATAR_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
}
